/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InlineResponse20015Data model module.
 * @module model/InlineResponse20015Data
 * @version 1.0.0
 */
class InlineResponse20015Data {
    /**
     * Constructs a new <code>InlineResponse20015Data</code>.
     * @alias module:model/InlineResponse20015Data
     */
    constructor() { 
        
        InlineResponse20015Data.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineResponse20015Data</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineResponse20015Data} obj Optional instance to populate.
     * @return {module:model/InlineResponse20015Data} The populated <code>InlineResponse20015Data</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineResponse20015Data();

            if (data.hasOwnProperty('student_id')) {
                obj['student_id'] = ApiClient.convertToType(data['student_id'], 'Number');
            }
            if (data.hasOwnProperty('permission')) {
                obj['permission'] = ApiClient.convertToType(data['permission'], 'String');
            }
            if (data.hasOwnProperty('source')) {
                obj['source'] = ApiClient.convertToType(data['source'], 'Number');
            }
            if (data.hasOwnProperty('date_permission')) {
                obj['date_permission'] = ApiClient.convertToType(data['date_permission'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Boolean');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'String');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} student_id
 */
InlineResponse20015Data.prototype['student_id'] = undefined;

/**
 * @member {String} permission
 */
InlineResponse20015Data.prototype['permission'] = undefined;

/**
 * @member {Number} source
 */
InlineResponse20015Data.prototype['source'] = undefined;

/**
 * @member {String} date_permission
 */
InlineResponse20015Data.prototype['date_permission'] = undefined;

/**
 * @member {Boolean} status
 */
InlineResponse20015Data.prototype['status'] = undefined;

/**
 * @member {String} updated_at
 */
InlineResponse20015Data.prototype['updated_at'] = undefined;

/**
 * @member {String} created_at
 */
InlineResponse20015Data.prototype['created_at'] = undefined;

/**
 * @member {Number} id
 */
InlineResponse20015Data.prototype['id'] = undefined;






export default InlineResponse20015Data;

